/**
 * Custom Cart Trigger
 * 1. Intercepts AJAX requests (fetch & XHR) to /cart/add to open the custom cart drawer.
 * 2. Intercepts standard form submissions to /cart/add and upgrades them to AJAX.
 */
(function () {
    console.log('[CustomCartTrigger] Initializing...');

    const shouldOpenCart = (url) => {
        if (!url) return false;
        // Check for both .js endpoint and standard page endpoint
        return url.includes('/cart/add');
    };

    const triggerCart = () => {
        console.log('[CustomCartTrigger] Item added detected. Opening cart...');
        if (window.openCustomCart) {
            // Small delay to ensure Shopify's internal state settles 
            setTimeout(() => {
                window.openCustomCart();
            }, 100);
        } else {
            console.warn('[CustomCartTrigger] window.openCustomCart not found!');
        }
    };

    // --------------------------------------------------------------------------
    // 1. Network Interceptors (for existing AJAX calls from Theme or Apps)
    // --------------------------------------------------------------------------

    // Intercept Fetch
    const originalFetch = window.fetch;
    window.fetch = function () {
        return originalFetch.apply(this, arguments).then((response) => {
            try {
                const arg0 = arguments[0];
                let url = '';
                if (typeof arg0 === 'string') {
                    url = arg0;
                } else if (arg0 instanceof Request) {
                    url = arg0.url;
                }

                if (shouldOpenCart(url) && response.ok) {
                    triggerCart();
                }
            } catch (e) {
                console.error('[CustomCartTrigger] Error in fetch interceptor:', e);
            }
            return response;
        });
    };

    // Intercept XHR
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
        this._url = url;
        return originalOpen.apply(this, arguments);
    };

    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
        this.addEventListener('load', function () {
            try {
                const checkUrl = this._url || this.responseURL;
                if (checkUrl && shouldOpenCart(checkUrl)) {
                    if (this.status >= 200 && this.status < 300) {
                        triggerCart();
                    }
                }
            } catch (e) {
                console.error('[CustomCartTrigger] Error in XHR interceptor:', e);
            }
        });
        return originalSend.apply(this, arguments);
    };

    // --------------------------------------------------------------------------
    // 2. Form Submission Interceptor (Fallout/Upgrade for standard forms)
    // --------------------------------------------------------------------------
    document.addEventListener('submit', function (e) {
        const form = e.target;
        if (form && form.action && shouldOpenCart(form.action) && form.method.toLowerCase() === 'post') {

            // If logic elsewhere (like base.js) already prevented default, 
            // we assume it is handling the AJAX submit. Our Network Interceptor will catch that.
            if (e.defaultPrevented) {
                console.log('[CustomCartTrigger] Form submission prevented elsewhere (likely existing AJAX Cart). Network interceptor will handle.');
                return;
            }

            // Otherwise, intercept standard submit
            console.log('[CustomCartTrigger] Standard form submit detected. Intercepting...');
            e.preventDefault();

            const formData = new FormData(form);
            // Add sections param if we want partially rendered sections (optional)
            // formData.append('sections', 'custom-cart'); 

            const config = {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/javascript, application/json'
                }
            };

            fetch('/cart/add.js', config)
                .then(res => res.json())
                .then(data => {
                    if (data.status === 422) { // Error (e.g. Sold Out)
                        // Simple alert fallback. 
                        // Ideally we'd show the error in the UI, but without specific selectors that's hard.
                        alert(data.description || 'Error adding item to cart.');
                    } else {
                        // Success
                        // The network interceptor *might* fire too (since we just called fetch!), 
                        // but triggerCart() creates a harmless redundant call to openCustomCart() 
                        triggerCart();
                    }
                })
                .catch(err => {
                    console.error('[CustomCartTrigger] Error submitting form:', err);
                });
        }
    });

})();
